module.exports = __webpack_public_path__ + "static/media/mandibular.a9c14b96.png";